<script>
import { euroCouponsCouponMethods } from "@state/helpers";

export default {
  name: "EuroCouponsCouponApprove",
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: true,
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      toDelete: {},
    };
  },
  computed: {},

  mounted: function () {
    let context = this;
    if (context.instanceJson.url) {
      context.toDelete = {
        ...context.instanceJson,
      };
      context.getObject();
    } else {
      context.oncancel();
    }
  },

  methods: {
    ...euroCouponsCouponMethods,

    getObject() {
      let context = this;
      const promise = context.fetchEuroCouponsCouponDetail(context.toDelete.url);
      return promise
        .then((data) => {
          context.toDelete = { ...data };
          context.loading = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.loading = false;
          context.oncancel();
        });
    },

    inactiveObject() {
      let context = this;
      context.submitting = true;
      let payload = {
        action: "inactive",
        coupons: [this.toDelete],
      };
      const promise = context.approveInactiveEuroCouponsCoupon(payload);
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            `${context.$t("coupon")} ${context.$t("inactived")} ${context.$t(
              "correctly"
            )}`
          );
          setTimeout(() => {
            context.submitting = false;
            context.oncomplete();
          }, 1000);
        })
        .catch((error) => {
          context.submitting = false;
          context.$axios_error_noty(error, context);
        });
    },
  },
};
</script>

<template>
  <b-modal
    id="inactive-modal"
    v-model="modalShow"
    :title="`${$t('Inactive')} ${$t('coupon')}`"
    ok-title="Inactive"
    ok-variant="danger"
    @hidden="oncancel"
    @ok.prevent="inactiveObject"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <p class="text-center">
            {{ $t("¿Estas seguro de inactivar") }} el bono
            {{ toDelete.name || toDelete.id }}?
          </p>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" :disabled="submitting" @click="cancel">
        Cancelar
      </b-button>
      <b-button size="sm" variant="danger" :disabled="submitting" @click="ok">
        <span v-if="!submitting">
          {{ $t("Inactive") }}
        </span>
        <b-spinner v-if="submitting" small label="Spinning" variant="light"> </b-spinner>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss"></style>
